import BasePMPExcludedComplete from "../../basePMPExcluded/basePMPExcludedComplete";

export default class CancelPMPExcludedComplete extends BasePMPExcludedComplete {
  handleReturnPageName = () => {
    return "Cancel PMP Excluded";
  };
}
